import Footer from "../../../components/footer/Footer";
import Navbar from "../../../components/navbar/navbar";
import TitleSection from "../../../components/title-section/title-section";
import "./gen-cargo-main.css";
import fragileIcon from "../../../assets/imgs/prepare-shipment/general_cargo/fragilIcon.svg";
import courierIcon from "../../../assets/imgs/prepare-shipment/general_cargo/courierIcon.svg";
import heavyWeightIcon from "../../../assets/imgs/prepare-shipment/general_cargo/heavyWeightIcon.svg";
import generalCargoImg from "../../../assets/imgs/services/international/general.jpg";
import alertImg from "../../../assets/imgs/prepare-shipment/general_cargo/alert-icon.png";
import boxIcon from "../../../assets/imgs/prepare-shipment/general_cargo/box-icon.svg";
import dropIcon from "../../../assets/imgs/prepare-shipment/general_cargo/drop-icon.svg";
import cupIcon from "../../../assets/imgs/prepare-shipment/general_cargo/cup-icon.svg";
import letterIcon from "../../../assets/imgs/prepare-shipment/general_cargo/letter-icon.svg";
import heavyIcon from "../../../assets/imgs/prepare-shipment/general_cargo/heavy-icon.svg";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import ViewQuillComponent from "../../dashboard/admin/textos/viewQuillComponent";
import navBarEn from "../../../translations/en/navbar.json";
import navBarEs from "../../../translations/es/navbar.json";
import Helmet from "react-helmet";

function GenCargoMain() {
  const [tGenCargo] = useTranslation("genCargoPage");
  const [tSMetaData] = useTranslation("metaData");
  const idComponent = "19c35b1b-1e1f-40e8-a3c6-db448732b90b";
  const idGeneralSections = "279132ba-7945-43d3-bc88-022df0740024";
  const [item1, setItem1] = useState("");
  const [item2, setItem2] = useState("");
  const [item3, setItem3] = useState("");
  const [item4, setItem4] = useState("");
  const [item5, setItem5] = useState("");
  const [dataInformation, setDataInformation] = useState({
    "General cargo": {
      título: "General cargo",
      nota: "NOTA",
      text: "Un embarque puede considerarse con más de una clasificación según el tipo de carga (ej. botellas de vino: húmeda y frágil), por lo que en esos casos se deben contemplar todos los materiales de empaque que apliquen respectivamente.",
    },
  });

  sessionStorage.setItem(
    "routeEs",
    `/${navBarEs["category-services"].shipments}/${
      Object.keys(navBarEs["prepare-shipment-submenu"])[1]
    }`
  );

  sessionStorage.setItem(
    "routeEn",
    `/${navBarEn["category-services"].shipments}/${
      Object.keys(navBarEn["prepare-shipment-submenu"])[1]
    }`
  );

  const getTexts = async () => {
    let currentLng = "";
    localStorage.getItem("lng")
      ? (currentLng = `${localStorage.getItem("lng")}`)
      : (currentLng = "es");

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND}/api/textWeb/text/${idComponent}`);

      const responseItems = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND}/api/textWeb/text/${idGeneralSections}`);

      if (currentLng === "es") {
        setDataInformation(response.data.textWeb.text_es["General cargo"]);
        setItem1(responseItems.data.textWeb.text_es["Seca"].content);
        setItem2(responseItems.data.textWeb.text_es["Húmedos"].content);
        setItem3(responseItems.data.textWeb.text_es["Carga Frágil"].content);
        setItem4(responseItems.data.textWeb.text_es["Mensajería"].content);
        setItem5(responseItems.data.textWeb.text_es["Carga Pesada"].content);
      } else {
        setDataInformation(response.data.textWeb.text_us["General cargo"]);
        setItem1(responseItems.data.textWeb.text_us["Seca"].content);
        setItem2(responseItems.data.textWeb.text_us["Húmedos"].content);
        setItem3(responseItems.data.textWeb.text_us["Carga Frágil"].content);
        setItem4(responseItems.data.textWeb.text_us["Mensajería"].content);
        setItem5(responseItems.data.textWeb.text_us["Carga Pesada"].content);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getTexts();
  }, []);

  const currentLang = localStorage.getItem("lng") || "es";

  const cargoData = [
    {
      title: "Seca",
      icon: boxIcon,
      items: [
        "Caja de cartón o madera.",
        "Bolsa de plástico de alto calibre (que no exceda 30 kg por pieza).",
        "Costal de yute o lona.",
        "Cuñete de cartón, plástico o metal."
      ],
      noteTitle: "Tome en cuenta que",
      notes: [
        "Los dispositivos electrónicos deben presentarse en su empaque original, o bien, en caja de cartón, madera o algún material rígido lo suficientemente resistente para proteger el contenido."
      ]
    },
    {
      title: currentLang === "es" ? "Húmedos" : "Wet",
      icon: dropIcon,
      items: [
        "Contenedor primario a prueba de filtraciones.",
        "Contenedor secundario a prueba de filtraciones (como hielera de plástico sin desagüe ni unicel).",
        "Material amortiguante.",
        "Material absorbente."
      ],
      noteTitle: "Tome en cuenta que",
      notes: [
        "Las botellas (embalaje primario) no deben golpearse entre sí y no debe haber espacios vacíos dentro de la caja de cartón o hielera (embalaje secundario).",
        "Se podrá usar caja de cartón sólo si el empaque primario es a prueba de filtraciones."
      ]
    },
    {
      title: "Carga frágil",
      icon: cupIcon,
      items: [
        "Caja de cartón rígido, madera o metal.",
        "Reja de madera exterior (la cual impedirá que la mercancía sea impactada directamente y se origine algún daño).",
        "Material amortiguante."
      ],
      noteTitle: "Tome en cuenta que",
      notes: [
        "Debe mantener un espacio entre la mercancía y la caja para el material amortiguante."
      ]
    },
    {
      title: "Mensajería",
      icon: letterIcon,
      paragraph: "El contenido deberá encontrarse en sobres de papel o plástico o cualquier material que junto con los documentos no supere los 3 kilogramos de peso."
    },
    {
      title: "Carga Pesada (+80 kg)",
      icon: heavyIcon,
      paragraph: "La carga debe estar flejada una tarima de madera, excepto si la pieza cuenta con una superficie de contacto plana y agarraderas u orificios para cargar y si el peso y las dimensiones facilitan su manipulación."
    }
  ];

  return (
    <div>
      <Helmet>
        <title>{tSMetaData("preparaEmbarqueCargaGeneral.title")}</title>
        <meta
          name="description"
          content={tSMetaData("preparaEmbarqueCargaGeneral.description")}
        />
      </Helmet>
      <Navbar />
      {/* <TitleSection title={tGenCargo("general-cargo.general-cargo")} /> */}
      <div className="container-fluid blue-container">
        <div className="row justify-content-center align-items-center full-height-row">
          {/* Usamos col-auto para que la columna se ajuste al contenido central */}
          <div className="col-auto">
            <div className="service-content-wrapper">
              <div className="image-circle-container">
                <img src={generalCargoImg} alt="Carga general"  className="cargo-image-rounded" />
              </div>
              <div className="text-container">
                <h4 className="service-title">Carga general</h4>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid" style={{backgroundColor: '#F2F2EE'}}>
        <div className="container note-container">
          <div className="row">
            <div className="col">
              <div className="note-icon">
                <img src={alertImg} />
                <p>NOTA</p>
              </div>
              <div className="note-text">
                Un embarque puede considerarse con más de una clasificación según el tipo de carga (ej. botellas de vino: húmeda y frágil), por lo que en esos casos se deben contemplar todos los materiales de empaque que apliquen respectivamente.
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container cargo-container my-5">
        {/* row-cols-1 para móviles, row-cols-md-3 para tablets, row-cols-lg-5 para PC */}
        <div className="row row-cols-1 row-cols-md-3 row-cols-lg-5 g-0">
          
          {cargoData.map((cargo, index) => (
            <div className="col cargo-card-wrapper" key={index}>
              <div className="cargo-card">
                
                {/* Contenedor del Icono */}
                <div className="cargo-icon-box mx-auto">
                  <img src={cargo.icon} alt={cargo.title} />
                </div>
                
                {/* Título */}
                <h3 className="cargo-title text-center mt-3">{cargo.title}</h3>
                
                {/* Lista de viñetas (si aplica) */}
                {cargo.items && (
                  <ul className="cargo-list">
                    {cargo.items.map((item, i) => <li key={i}>{item}</li>)}
                  </ul>
                )}

                {/* Párrafo sin viñetas (para mensajería y carga pesada) */}
                {cargo.paragraph && (
                  <p className="cargo-paragraph">{cargo.paragraph}</p>
                )}

                {/* Sección "Tome en cuenta que" (si aplica) */}
                {cargo.noteTitle && (
                  <div className="cargo-notes-section">
                    <h4 className="cargo-note-title">{cargo.noteTitle}</h4>
                    <ul className="cargo-list">
                      {cargo.notes.map((note, i) => <li key={i}>{note}</li>)}
                    </ul>
                  </div>
                )}

              </div>
            </div>
          ))}

        </div>
        <div className="row mt-5">
          <div className="col text-center">
            <Link id="btnQuoteGeneralCargo" className="btn-quote-pink" to="/quote">
              {tGenCargo("general-cargo.quote")}
            </Link>
          </div>
        </div>
      </div>

      {/* <div className="container mt-5">
        <p className="title-h3">
          {dataInformation["nota"] ?? tGenCargo("general-cargo.note")}
        </p>
        <p className="text-gray">
          {dataInformation["text"] ?? tGenCargo("general-cargo.text-1")}
        </p>
        <div className="article-container my-4">
          <article className="container text-gray">
            <div className="row">
              <div className="icon-container col-12 col-md-2 d-flex flex-column justify-content-center align-items-center">
                <img className="icons" src={boxIcon} alt="Box Icon" />
                <p className="d-flex justify-content-center py-3 text-premium-blue text-center">
                  {tGenCargo("article1.title")}
                </p>
              </div>
              <div className="col-12 col-md-10 p-3">
                <ViewQuillComponent
                  content={
                    item1
                      ? JSON.parse(item1)
                      : JSON.parse(tGenCargo("article1.content"))
                  }
                  type={"json"}
                />
              </div>
            </div>
          </article>
          <article className="container text-gray">
            <div className="row">
              <div className="icon-container col-12 col-md-2 d-flex flex-column justify-content-center align-items-center">
                <img className="icons" src={dropIcon} alt="Drop Icon" />
                <p className="d-flex justify-content-center py-3 text-premium-blue text-center">
                  {tGenCargo("article2.title")}
                </p>
              </div>
              <div className="col-12 col-md-10 p-3">
                <ViewQuillComponent
                  content={
                    item2
                      ? JSON.parse(item2)
                      : JSON.parse(tGenCargo("article2.content"))
                  }
                  type={"json"}
                />
              </div>
            </div>
          </article>
          <article className="container text-gray">
            <div className="row">
              <div className="icon-container col-12 col-md-2 d-flex flex-column justify-content-center align-items-center">
                <img className="icons" src={fragileIcon} alt="Fragil Icon" />
                <p className="d-flex justify-content-center py-3 text-premium-blue text-center">
                  {tGenCargo("article3.title")}
                </p>
              </div>
              <div className="col-12 col-md-10 p-3">
                <ViewQuillComponent
                  content={
                    item3
                      ? JSON.parse(item3)
                      : JSON.parse(tGenCargo("article3.content"))
                  }
                  type={"json"}
                />
              </div>
            </div>
          </article>
          <article className="container text-gray">
            <div className="row">
              <div className="icon-container col-12 col-md-2 d-flex flex-column justify-content-center align-items-center">
                <img
                  className="icons pt-3"
                  src={courierIcon}
                  alt="Messenger service Icon"
                />
                <p className="d-flex justify-content-center py-3 text-premium-blue text-center">
                  {tGenCargo("article4.title")}
                </p>
              </div>
              <div className="col-12 col-md-10 p-3">
                <ViewQuillComponent
                  content={
                    item4
                      ? JSON.parse(item4)
                      : JSON.parse(tGenCargo("article4.content"))
                  }
                  type={"json"}
                />
              </div>
            </div>
          </article>
          <article className="container text-gray">
            <div className="row">
              <div className="icon-container col-12 col-md-2 d-flex flex-column justify-content-center align-items-center">
                <img
                  className="icons"
                  src={heavyWeightIcon}
                  alt="Heavy weight Icon"
                />
                <p className="d-flex justify-content-center py-3 text-premium-blue text-center">
                  {tGenCargo("article5.title")}
                  <br />
                  {tGenCargo("article5.title-2")}
                </p>
              </div>
              <div className="col-12 col-md-10 p-3 d-flex">
                <ViewQuillComponent
                  content={
                    item5
                      ? JSON.parse(item5)
                      : JSON.parse(tGenCargo("article5.content"))
                  }
                  type={"json"}
                />
              </div>
            </div>
          </article>
        </div>
        <div className="d-flex justify-content-center justify-content-lg-end align-items-center my-5 py-2 py-md-5">
          <Link id="btnQuoteGeneralCargo" className="btn-blue" to="/quote">
            {tGenCargo("general-cargo.quote")}
          </Link>
        </div>
      </div> */}
      <Footer />
    </div>
  );
}

export default GenCargoMain;
